export default class LeaderBoard extends Phaser.State {

    constructor(){
        super ();
        this.scoresboard =[]

        let url = `http://forefront.international/my/welcomepawsperity/API/leaderboards.php?action=get`
        fetch(url)
        .then((response)=> response.json())
        .then((res)=>{
            this.scoresboard = res.scoreboards
        })
    }

    create() {
        this._attachDOMEvents()
    }

    _attachDOMEvents(){
        this.game.paused = true;
        // Enable leaderboard modal
        const gameLeaderboardModal = document.getElementById('game-leaderboard-modal');
        this.scoresboard.forEach((list,i)=>{
            if(i <=2){
                let name = `lead${i+1}name`
                let score = `lead${i+1}score`
                let img = `lead${i+1}img`
                let images = ''
                let alt =''
                if(list.dogtype == '1' || list.dogtype == "dog-yellow"|| list.dogtype == "dog_yellow"){
                    images = ('images/leaderboard-thug-win.png')
                    alt ='thug'
                }else if(list.dogtype == '2' || list.dogtype == "doggo"){
                    images = ('images/leaderboard-pawter-win.png')
                    alt ='pawter'
                }else if(list.dogtype == '3' || list.dogtype == "dog-orange" || list.dogtype == "dog_orange"){
                    images = ('images/leaderboard-furlash-win.png')
                    alt ='furlash'
                }

                document.getElementById(name).innerHTML = list.name
                document.getElementById(score).innerHTML = list.scores
                document.getElementById(img).src = images
            }else if( i < 10){
                let name = list.name
                let score = list.scores
                let images = ''
                let alt =''
                if(list.dogtype == '1' || list.dogtype == "dog-yellow"|| list.dogtype == "dog_yellow"){
                    images = ('images/leaderboard-thug.png')
                    alt ='thug'
                }else if(list.dogtype == '2' || list.dogtype == "doggo"){
                    images = ('images/leaderboard-pawter.png')
                    alt ='pawter'
                }else if(list.dogtype == '3' || list.dogtype == "dog-orange"|| list.dogtype == "dog_orange"){
                    images = ('images/leaderboard-furlash.png')
                    alt ='furlash'
                }
                let tempDiv = `<div class="leaderboard-list animated fadeInUp">
                <div class="row">
                  <div class="col-1">
                    <div class="leaderboard-list-number">${i+1}</div>
                  </div>
                  <div class="col-11">
                    <div class="leaderboard-list-details">
                      <div class="row align-items-center">
                        <div class="col-3">
                          <div class="leaderboard-list-dog"><img src="${images}" alt="${alt}"></div>
                        </div>
                        <div class="col-6">
                          <div class="leaderboard-list-name">${name}</div>
                        </div>
                        <div class="col-3">
                          <div class="leaderboard-list-points">${score}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>`

                document.getElementById('leaderboard-list-cont').innerHTML += tempDiv;
            }
        })
        
        let images ='';
        let alt ='';
        if(this.game.dogType == 1 || this.game.dogType == "dog-yellow"|| this.game.dogType == "dog_yellow"){
            images = ('images/leaderboard-thug-win.png')
            alt ='thug'
        }else if(this.game.dogType == 2 || this.game.dogType == "doggo"){
            images = ('images/leaderboard-pawter-win.png')
            alt ='pawter'
        }else if(this.game.dogType == 3 || this.game.dogType == "dog-orange" || this.game.dogType == "dog_orange"){
            images = ('images/leaderboard-furlash-win.png')
            alt ='furlash'
        }
        document.getElementById('lead-self-name').innerHTML = this.game.gameName
        document.getElementById('lead-self-score').innerHTML = this.game.scores.toFixed()
        document.getElementById('lead-self-share').addEventListener('click',()=>{
            let scores = String(this.game.scores.toFixed())
            FB.ui({
                method: 'share',
                href: 'http://forefront.international/my/welcomepawsperity/game/',
                hashtag: `#WelcomePawsperity`,
                quote:`I helped Wang Cai bring ${scores} coins home! Do you think you can beat my score?`,
                description:encodeURIComponent('The sequel to Bring Wang Cai Home has arrived. Treasures have been unearthed in the streets of Paw-tune Valley, and Wang Cai is inviting you to embark on this brand new quest to bring the pawsperity home!'),
                thumbnail:'http://forefront.international/my/welcomepawsperity/images/fb-share-img.jpg',
                mobile_iframe:true
            }, (response)=>{});
            // console.log('thing happen')
            // window.open('https://www.facebook.com/sharer/sharer.php?u=http://forefront.international/my/welcomepawsperity&hashtag=%23MyBestScores', '_blank');
        },this)

        document.getElementById('close-leader').addEventListener('click',()=>{
            this.state.start('PreSelection');
            gameLeaderboardModal.classList.remove('is-active');
        })

        gameLeaderboardModal.classList.add('is-active');
    }
}




// WEBPACK FOOTER //
// ./js/states/leaderboard.js